import i18n from '@/main';

function tradutorDeCamadas(camada) {
    const camadasTraduzidas = {
        'Amazônia Protege': i18n.t('mensagens.camadas.AMAZONIA_PROTEGE'),
        'Áreas embargadas (Goiás)': i18n.t('mensagens.camadas.AREA_EMBARGADA_GOIAS'),
        'Áreas embargadas (IBAMA)': i18n.t('mensagens.camadas.AREA_EMBARGADA'),
        'Áreas embargadas (ICMBIO)': i18n.t('mensagens.camadas.AREA_EMBARGADA_ICMBIO'),
        'Áreas Embargadas (SEDAM-RO)': i18n.t('mensagens.camadas.AREA_EMBARGADA_SEDAM_RO'),
        'Áreas Embargadas - LDI': i18n.t('mensagens.camadas.LDI'),
        'Áreas embargadas - lista': i18n.t('mensagens.camadas.LISTA_AREA_EMBARGADA'),
        'Áreas Embargadas Piauí': i18n.t('mensagens.camadas.LISTA_AREA_EMBARGADA_PIAUI'),
        'Áreas embargadas (SEMA-MT)': i18n.t('mensagens.camadas.AREA_EMBARGADA_SEMA_MT'),
        'Áreas embargas (SEMA-MT)': i18n.t('mensagens.camadas.AREA_EMBARGADA_SEMA_MT'),
        'Áreas Silvestres Protegidas do Paraguai': i18n.t('mensagens.camadas.AREAS_SILVESTRES_PROTEGIDAS_PARAGUAI'),
        'Assentamentos - INCRA': i18n.t('mensagens.camadas.INCRA_ASSENTAMENTOS'),
        'Desmatamento INFONA': i18n.t('mensagens.camadas.DESMATAMENTO_INFONA_PARAGUAI'),
        'DETER Amazônia Legal': i18n.t('mensagens.camadas.DETER_AMAZONIA'),
        'DETER cerrado': i18n.t('mensagens.camadas.DETER_CERRADO'),
        'Florestas Públicas': i18n.t('mensagens.camadas.FLORESTAS_PUBLICAS'),
        'Lista Áreas Embargadas do Piauí': i18n.t('mensagens.camadas.LISTA_AREA_EMBARGADA_PIAUI'),
        'Lista Suja de Trabalho Escravo': i18n.t('mensagens.camadas.LISTA_SUJA_TRABALHO_ESCRAVO'),
        'MapBiomas': i18n.t('mensagens.camadas.MAPBIOMAS'),
        'Moratória da Soja': i18n.t('mensagens.inteligenciaTerritorial.moratoriaDaSoja'),
        'Moratória da Soja - Pontos': i18n.t('mensagens.camadas.MORATORIA_SOJA_PONTOS'),
        'PRODES': i18n.t('mensagens.camadas.PRODES'),
        'PRODES Caatinga': i18n.t('mensagens.camadas.PRODES_CAATINGA'),
        'PRODES Cerrado': i18n.t('mensagens.camadas.PRODES_CERRADO'),
        'PRODES Mata Atlântica': i18n.t('mensagens.camadas.PRODES_MATA_ATLANTICA'),
        'PRODES Pampa': i18n.t('mensagens.camadas.PRODES_PAMPA'),
        'PRODES Pantanal': i18n.t('mensagens.camadas.PRODES_PANTANAL'),
        'Protocolo Verde dos Grãos': i18n.t('mensagens.camadas.PROTOCOLO_VERDE_GRAOS'),
        'Queimadas': i18n.t('mensagens.camadas.QUEIMADAS'),
        'Quilombolas - INCRA': i18n.t('mensagens.camadas.INCRA_QUILOMBOLAS'),
        'Reserva da Biosfera': i18n.t('mensagens.camadas.RESERVA_BIOSFERA_PARAGUAI'),
        'Sítios arqueológicos': i18n.t('mensagens.camadas.SITIOS_ARQUEOLOGICOS'),
        'Sítios Ramsar': i18n.t('mensagens.camadas.SITIO_RAMSAR_PARAGUAI'),
        'Terras indígenas': i18n.t('mensagens.camadas.TERRA_INDIGENA'),
        'Terras indígenas Paraguai': i18n.t('mensagens.camadas.TERRA_INDIGENA_PARAGUAI'),
        'Unidades de conservação de proteção integral': i18n.t('mensagens.camadas.UNIDADE_CONSERVACAO_PI'),
        'Unidades de conservação de uso sustentável': i18n.t('mensagens.camadas.UNIDADE_CONSERVACAO_US'),
        'Zonas de amortecimento - Unidades de conservação de proteção integral': i18n.t('mensagens.camadas.ZONA_AMORTECIMENTO_UNIDADE_CONSERVACAO_PI'),
        'CAR - Situação': i18n.t('mensagens.camadas.SITUACAO_CAR_SANTANDER')
    };

    return camadasTraduzidas[camada] || camada;
}

export default {
    traduzirCamada(camada) {
        return tradutorDeCamadas(camada);
    }
};
